import { registerPlugin } from "@capacitor/core";

// Ponte com o plugin nativo custom NotificationActionsPlugin.java
// (android-capacitor/android/app/src/main/java/gpsdrive/com/br/push/) —
// só existe no app Android nativo empacotado (Capacitor), nunca no
// navegador/PWA. Ver use-native-notification-actions.ts pra quem consome.
export interface PendingNotificationAction {
  action?: "open_map";
  deviceId?: string;
  ruleId?: string;
}

export interface NotificationActionsApi {
  getPending(): Promise<PendingNotificationAction>;
}

export const NotificationActions = registerPlugin<NotificationActionsApi>("NotificationActions");
